export { default as GDMInputMask } from './GDMInputMask';

export type { GDMInputMaskComponent } from './GDMInputMask.type';
